module.exports = __webpack_public_path__ + "static/media/marisa1.4dcd5697.mp3";